<template>
    <div v-if="allTeams != null" class="row">
        <div v-for="item in allTeams.edges" class="club-section-content col-lg-2 col-sm-4 col-8">
            <a class="club-section-item" :href="embed ? item.node.iframeUrl : item.node.url">
                <div class="club-section-item__image">
                    <img :src="item.node.logo != null ? item.node.logo : item.node.logoUrl" :alt="item.node.name">
                </div>
                <div class="club-section-item__description text-center">
                    <h5>{{ item.node.name }}</h5>
                </div>
            </a>
        </div>
        <div v-if="loading" class="text-center club-section-loading"><h3>Loading...</h3></div>
        <div v-else class="channel-detail-results-load">
            <button class="button button--secondary" v-if="allTeams.pageInfo && allTeams.pageInfo.hasNextPage" @click="loadMore">
                <div class="add-button__icon"><i class="fas fa-plus"></i></div>
                <span>Load more</span></button>
        </div>
    </div>
</template>
<script>
    import gql from 'graphql-tag'

    function getFilterItemsQuery() {
        return gql`
        query ClubTeams($clubId: ID!, $offset: String, $step: Int!, $customSlug: String) {
            allTeams(club: $clubId, first: $step, after: $offset, customSlug: $customSlug) {
                pageInfo{
                  hasNextPage
                  hasPreviousPage
                  startCursor
                  endCursor
                }
                edges{
                    node{
                        name,
                        logo,
                        url,
                        iframeUrl
                    }
                }
            }
        }`
    }

    export default {
        name: "Teams",
        props: {
            clubId: {
                type: String,
                required: true
            },
            embed: {
                type: Boolean,
                required: false,
                default: false
            },
            customSlug: {
                type: String,
                default: ''
            }
        },
        data() {
            return {
                loading: 0,
                allTeams: null
            }
        },
        methods: {
            loadMore() {
                let endCursor = this.allTeams.pageInfo.endCursor
                this.$apollo.queries.allTeams.fetchMore({
                    variables: {
                        offset: endCursor
                    },
                    updateQuery: (previousQueryResult, {fetchMoreResult}) => {
                        if (!fetchMoreResult) {
                            return previousQueryResult;
                        }
                        return Object.assign({}, fetchMoreResult, {
                            allTeams: {
                                ...fetchMoreResult.allTeams,
                                edges: [...previousQueryResult.allTeams.edges, ...fetchMoreResult.allTeams.edges]
                            }
                        });
                    }
                });
            }
        },
        apollo: {
            allTeams: {
                query: getFilterItemsQuery(),
                loadingKey: 'loading',
                variables() {
                    return {
                        clubId: this.clubId,
                        step: 32,
                        offset: this.offsetLocal,
                        customSlug: this.customSlug
                    }
                }
            }
        }
    }
</script>
